import { Action } from 'redux';
import { Epic, combineEpics, ofType } from 'redux-observable';
import { map, switchMap, catchError } from 'rxjs/operators';

import { observeChanges } from '../firebase';
import { StoreState } from '../types';
import { UserSignedIn, USER_SIGNED_IN } from '../actions/AuthActions';
import { userSessionUpdated } from '../actions/SessionActions';

const userSessionsUpdatedEpic: Epic<Action, Action, StoreState> =
    (action$, store$) =>
        action$
            .pipe(
                ofType<Action, UserSignedIn>(USER_SIGNED_IN),
                switchMap(a => observeChanges(`users/${a.value.user.uid}/sessions`)),
                map(userSessionUpdated),
                catchError((err, caught) => {
                    console.log('userSessionsUpdatedEpic', err);
                    return caught;
                })
            );

export default combineEpics(
    userSessionsUpdatedEpic,
);
